import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const getAllWebhooks = async ({ tenantId }, { client }) => {
    const data = await client.pim.request(graphql(`
      query GetAllWebhooks($tenantId: ID!) {
        webhook {
          getMany(tenantId: $tenantId) {
            name
            url
            id
          }
        }
      }
    `), { tenantId });
    return data.webhook.getMany;
};
